import { faAnglesLeft, faBars } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Divider, Layout, Drawer } from "antd";
import { useState } from "react";
import logo from "../../assets/logo.png";
import logoSvg from "../../assets/Logo.svg";
import { useAuth } from "../../config/AuthProvider";
import ContiMenu from "./ContiMenu";
import UserDropdownMenu from "./UserDropdownMenu";
import { useNavigate } from "react-router-dom";

const { Content, Sider, Header } = Layout;

const ContiLayout = ({ children }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Layout className="min-h-screen bg-gradient-to-br from-[#E2EBFF] to-[#C3DFCD] overflow-hidden">
      {/* Desktop Sidebar */}
      <Sider
        className="hidden lg:block !bg-white opacity-90 fixed top-0 left-0 h-full overflow-y-auto z-10 py-4 rounded-r-[50px] font-inter"
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        collapsedWidth="100px"
        onCollapse={(value) => setCollapsed(value)}
        width="280px"
        style={{ backgroundColor: "#F1F4F4" }}
      >
        <div className="flex flex-col justify-between h-full">
          <div className="flex flex-col gap-2">
            <img
              src={collapsed ? logoSvg : logo}
              className={`block mt-3 h-10 cursor-pointer ${collapsed ? "mx-auto" : "ml-7 w-52"}`}
              alt="Conti Logo"
              onClick={() => navigate("/")}
            />

            <div
              className={
                collapsed
                  ? `flex justify-center w-full mt-2`
                  : `flex justify-end mr-2 mt-2`
              }
            >
              <FontAwesomeIcon
                icon={collapsed ? faBars : faAnglesLeft}
                className="w-5 h-5 cursor-pointer"
                onClick={() => setCollapsed(!collapsed)}
              />
            </div>
            <ContiMenu
              className="w-[280px]"
              collapsed={collapsed}
              userPrivileges={user?.privileges}
              onMenuItemClick={() => {
                setDrawerOpen(false);
              }}
            />
          </div>

          <div className="mb-5 mx-2">
            <Divider style={{ borderTop: "0.5px solid #bdbdbd" }} />
            <UserDropdownMenu
              user={user}
              logout={logout}
              collapsed={collapsed}
            />
          </div>
        </div>
      </Sider>

      {/* Mobile / Tablet Top Navigation */}
      <Header className="lg:hidden flex items-center !justify-between px-4 bg-white shadow-md fixed top-0 left-0 w-full z-20">
        <img src={logoSvg} alt="Conti Logo" className="h-8 cursor-pointer" onClick={() => navigate("/")} />
        <FontAwesomeIcon
          icon={faBars}
          className="w-6 h-6 cursor-pointer"
          onClick={() => setDrawerOpen(true)}
        />
      </Header>

      {/* Drawer for Mobile Menu */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        styles={{ body: { padding: 0 } }}
      >
        <ContiMenu
          className="w-[280px]"
          collapsed={false}
          userPrivileges={user?.privileges}
          onMenuItemClick={() => {
            setDrawerOpen(false);
          }}
        />
        <Divider style={{ borderTop: "0.5px solid #bdbdbd" }} />
        <UserDropdownMenu user={user} logout={logout} collapsed={false} />
      </Drawer>

      {/* Main Content */}
      <Layout
        className={`w-full bg-gradient-to-br from-[#E2EBFF] to-[#C3DFCD] ${collapsed ? "lg:ml-28" : "lg:ml-72"
          } pt-16 lg:pt-0`} // add padding for mobile header
      >
        <Content>
          <div>{children}</div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ContiLayout;
